export default "__VITE_ASSET__3e984244__"